/**
 * 거래처 목록 일괄 상태 변경.
 * PATCH /admin/business-relationships/transaction-status 요청 body를 만든다.
 * 화면에서 체크한 줄을 그대로 targets 로 보낸다 — 서버가 거래처 단위로 접는다.
 */
import type {
  BusinessRelationshipBulkStatusTarget,
  BusinessRelationshipBulkStatusUpdateRequest,
  BusinessRelationshipResponse,
} from '@/entities/business/api/business.api';
import { BUSINESS_BULK_STATUS_MAX_TARGETS } from '@/entities/business/api/business.api';
import type { PharmaTransactionStatus } from '@/pages/clients/clientStatusUtils';

export { BUSINESS_BULK_STATUS_MAX_TARGETS };

/** 병원급은 같은 관계 ID에 의약품 행이 여러 개일 수 있어 drugCode까지 키로 쓴다 */
export const clientRowSelectionKey = (
  client: Pick<
    BusinessRelationshipResponse,
    'relationPharmaCompanyId' | 'drugCode'
  >,
): string =>
  `${client.relationPharmaCompanyId}::${client.drugCode?.trim() ?? ''}`;

export const toBulkStatusTarget = (
  client: Pick<
    BusinessRelationshipResponse,
    'relationPharmaCompanyId' | 'drugCode'
  >,
): BusinessRelationshipBulkStatusTarget => {
  const drugCode = client.drugCode?.trim();
  return {
    relationPharmaCompanyId: client.relationPharmaCompanyId,
    drugCode: drugCode || null,
  };
};

export const buildBulkStatusUpdateRequest = (
  clients: Array<
    Pick<BusinessRelationshipResponse, 'relationPharmaCompanyId' | 'drugCode'>
  >,
  status: PharmaTransactionStatus,
): BusinessRelationshipBulkStatusUpdateRequest => ({
  transactionStatus: status,
  targets: clients.map(toBulkStatusTarget),
});

/** 성공/부분실패 토스트 문구 */
export const formatBulkStatusResultMessage = (result: {
  successCount: number;
  failedCount: number;
}): string => {
  if (result.failedCount === 0) {
    return `${result.successCount}건의 거래 상태를 변경했습니다.`;
  }
  return `${result.successCount}건 변경, ${result.failedCount}건 실패`;
};
